module.exports = __webpack_public_path__ + "img/team-11.9129a470.jpg";